import { API } from "@project/common"
type AssessmentSettingCategoryPayload = {
  assessment_setting_id: number
  order: number
  show_display: boolean
  title: string
  assessment_item?: any[]
  operation: "EDIT" | "ADD"
}
type AssessmentSettingCategoryItemPayload = {
  assessment_category_id: number
  order: number
  show_display: boolean
  title: string
  assessment_entity_item?: any
  operation: "EDIT" | "ADD" | "SORT"
}
export const getAllAssessmentSettings = () => {
  return API.get("/assessment-setting")
}
export const createOrUpdateAssessmentSetting = ({
  values,
  settingId,
}: {
  values: any
  settingId?: number
}) => {
  return API.post(`/assessment-setting/${settingId}`, values)
}
export const createUpdateAssessmentSettingCategory = ({
  operation,
  category_id,
  ...data
}: AssessmentSettingCategoryPayload & { category_id: number | undefined }) => {
  if (operation === "EDIT") {
    return API.put(`/assessment-setting/update-category/${category_id}`, {
      ...data,
    })
  }

  return API.post("/assessment-setting/create-category", { ...data })
}

export const sortAssessmentSetting = ({
  values,
  type,
}: {
  values: any
  settingId?: number
  type: "CATEGORY" | "ITEM"
}) => {
  if (type === "ITEM") {
    return API.post(`/assessment-setting/sort-category-item`, values)
  }
  return API.post(`/assessment-setting/bulk-update`, values)
}
export const createUpdateAssessmentSettingCategoryItem = ({
  operation,
  item_id,
  ...data
}: AssessmentSettingCategoryItemPayload & { item_id: number | undefined }) => {
  if (operation === "EDIT") {
    return API.put(`/assessment-setting/create-category-item/${item_id}`, {
      ...data,
    })
  }
  return API.post("/assessment-setting/create-category-item", { ...data })
}
